export interface ISettingState {
    experimentalMode: boolean;
}

export const initialSettingsState: ISettingState = {
    experimentalMode: false,
};
